import React, { useState, useEffect } from "react";
import Tour from "reactour";
import { useLocation, useNavigate } from "react-router-dom";

const TourGuide = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(0); // Track current step
  const [steps, setSteps] = useState([]);

  useEffect(() => {
    const startTour = localStorage.getItem("startTour");
    if (startTour === "true" && location.pathname === "/dashboard") {
      setIsTourOpen(true);
      localStorage.removeItem("startTour"); // Prevent retrigger
    }
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname === "/dashboard") {
      setSteps([
        {
          selector: ".step-1",
          content: `Welcome to OnlyHands! This is your Dashboard—your hub for world-class MMA
content. Here, you’ll find media and posts from elite mixed martial arts coaches across
the globe. Follow along with this quick 7-step orientation to get started!`,
        },
        {
          selector: ".step-1-1",
          content: `This is where you’ll see content from the creators you’ve subscribed
to. Stay up to date with the latest techniques, drills, and insights from top-tier athletes.`,
        },
        // {
        //   selector: ".step-2-1",
        //   content: "Find new creators by discipline or trending content",
        //   action: () => navigate("/search/guide"),
        // },
        {
          selector: ".step-3-1",
          content: `Click this button to explore trending creators and discover media
posted by world-class fighters and coaches.`,
        },
        {
          selector: ".step-3",
          content: `Creator Profiles – Browse profiles of elite athletes and coaches. You’ll also find
sneak peeks of their exclusive content before subscribing.`,
          action: () => navigate("/community"),
        },
        {
          selector: ".step-4-1",
          content: `Action Center – Manage your experience here! Edit your profile, tweak your
settings, or log out (but let’s be real—you won’t want to).`,
        },
        {
          selector: ".step-4",
          content: `Edit Account – Customize your profile, update your preferences, and fine-tune
your OnlyHands experience.`,
          action: () => navigate("/edit-profile"),
        },
        {
          selector: ".step-6",
          content: `You’re all set! Your orientation is complete. Welcome to OnlyHands! Now go out
there, explore, and connect with your community.
`,
          action: () => navigate("/dashboard"),
        },
      ]);
    }
  }, [location.pathname, navigate]);

  return (
    <Tour
      steps={steps}
      isOpen={isTourOpen}
      onRequestClose={() => setIsTourOpen(false)}
      getCurrentStep={(step) => setCurrentStep(step)} // Track step changes
      styles={{
        badge: (base) => ({
          ...base,
          backgroundColor: "#FC0108", // Change step number color
          color: "#fff",
        }),
        dot: (base, state) => ({
          ...base,
          backgroundColor: state.current ? "#FC0108" : "#ccc", // Change dot color
        }),
        arrow: (base) => ({
          ...base,
          color: "#FC0108", // Change arrow hover color
        }),
      }}
    />
  );
};

export default TourGuide;
